<template>
  <div>
    <div class="user-card">
      <div class="border-bottom">
        <div class="pa-4 d-flex align-center overflow-text-hidden">
          <v-avatar v-if="item.image" class="mr-3"
            ><img :src="item.image"
          /></v-avatar>
          <v-avatar v-else class="mr-3"
            ><img src="/images/default-profile.jpg"
          /></v-avatar>
          <div class=" w-100">
            <h4 class="ma-0">{{ item.name }}</h4>
            <small :title="item.description" class="d-block">{{ item.description }}</small>
          </div>
        </div>
      </div>
      <div class="d-flex align-center border-bottom">
        <!-- <div class="mutual-friends pa-4">
        <v-avatar class="mutual-friend" size="16"></v-avatar>
        <v-avatar class="mutual-friend" size="16"></v-avatar>
        <v-avatar class="mutual-friend" size="16"></v-avatar>
      </div> -->
        <small class="ml-6">{{ item.members.length }} Members</small>
      </div>

      <div v-if="isRequest()">
        <div class="d-flex pa-4">
          <span class="ml-auto">
            <v-btn
              small
              @click="
                () => {
                  let obj = userRequests.find(
                    (request) => request.requested_to == item.id
                  );
                  cancelJoinGroup(obj.id);
                  if (search) {
                    search();
                  }
                }
              "
              class="ml-2"
              color="primary"
              >Cancel Request</v-btn
            >
          </span>
        </div>
      </div>
      <div v-else-if="!isJoin()">
        <div class="d-flex pa-4">
          <span class="ml-auto">
            <v-btn small @click="lc_join_group()" class="ml-2" color="primary"
              >Join</v-btn
            >
          </span>
        </div>
      </div>
      <div class="d-flex pa-4" v-else>
        <span class="ml-auto">
          <v-btn
            icon
            color="primary"
            v-if="item.owner_id == authUser.id"
            @click="
              data = item;
              dialog = true;
            "
            class="mr-2"
            ><i class="fa fa-pencil"></i
          ></v-btn>
          <v-btn small color="primary" :to="'/group/' + item.id">View</v-btn>
          <div v-if="isMine()" class="d-inline-block">
            <v-btn
              small
              class="ml-2"
              color="primary"
              @click="
                () => {
                  deleteGroup(item.id);
                  if (search) {
                    search();
                  }
                }
              "
              >Delete</v-btn
            >
          </div>
          <div v-else-if="isJoin()" class="d-inline-block">
            <v-btn small class="ml-2" color="primary" @click="lc_leave_group()"
              >Leave</v-btn
            >
          </div>
        </span>
      </div>
    </div>
    <v-dialog
      v-model="dialog"
      width="500"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Group</v-toolbar-title>
        </v-toolbar>
        <div class="pa-4">
          <v-form ref="ref_edit_group" @submit="lc_edit_group">
            <v-text-field
              label="Group Title"
              outlined
              solo
              dense
              flat
              v-model="data.name"
              :rules="[myrules.required]"
            ></v-text-field>
            <v-autocomplete
              label="Group Members"
              :items="userConnects"
              class="mt-5"
              outlined
              solo
              dense
              flat
              item-text="name"
              item-value="id"
              multiple
              v-model="data.members"
              :rules="[myrules.required]"
            ></v-autocomplete>
            <v-autocomplete
              label="Group Type"
              class="mt-5"
              outlined
              solo
              dense
              flat
              :items="['Public', 'Private']"
              v-model="data.type"
              :rules="[myrules.required]"
            ></v-autocomplete>
            <v-textarea
              placeholder="Group Description"
              class="mt-5"
              outlined
              v-model="data.description"
              :rules="[myrules.required]"
              solo
              dense
              flat
            ></v-textarea>
            <div class="d-flex mt-3">
              <v-btn
                color="red"
                class="white--text ml-auto mr-3"
                @click="dialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" type="submit">Save</v-btn>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "UserCard",
  props: ["item", "search"],
  data() {
    return {
      dialog: false,
      data: {},
      updateToggler: false,
    };
  },
  methods: {
    async lc_join_group() {
      await this.requestJoinGroup({
        requested_by: this.authUser.id,
        requested_to: this.item.id,
        owner_id: this.item.owner_id,
      });
      window.setTimeout(() => {
        console.log("in func")
        if (this.search) {
          this.search();
        }
      }, 3000);
    },
    async lc_leave_group() {
      console.log("leave_group");
      await this.leaveGroup({
        group_id: this.item.id,
        member_id: this.authUser.id,
      });
      if (this.search) {
        this.search();
      }
    },
    isJoin: function() {
      return this.item.members.find((member) => member == this.authUser.id);
    },
    isRequest() {
      console.log(
        this.userRequests.find(
          (request) => request.requested_to == this.item.id
        )
      );
      return this.userRequests.find(
        (request) => request.requested_to == this.item.id
      );
    },
    isMine() {
      return this.item.owner_id == this.authUser.id;
    },
    async lc_edit_group(e) {
      e.preventDefault();
      let validate = this.$refs.ref_edit_group.validate();
      if (validate) {
        let obj = {
          ...this.data,
        };
        await this.editGroup({ ...obj });
        this.dialog = false;
        this.$refs.ref_edit_group.reset();
      }
    },
  },
  mounted() {
    this.data = { ...this.item };
  },
  // watch:{
  //   groups(){
  //     console.log("abc");
  //     this.updateToggler = !this.updateToggler;
  //   }
  // }
};
</script>

<style scoped>
.user-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.mutual-friends {
  position: relative;
  height: 25px;
}
.mutual-friend {
  border: 1px solid #fff;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}
.mutual-friend:nth-child(1) {
  left: 5px;
  background: orange;
}
.mutual-friend:nth-child(2) {
  left: 10px;
  background: yellow;
}
.mutual-friend:nth-child(3) {
  left: 15px;
  background: red;
}
</style>
